<div *ngIf="editMode || simpleMode" class="edit-mode">
	<div *ngIf="!simpleMode" class="dv-value-edit">
		<button (click)="onApply()" [disabled]="false"><i class="fa fa-check"></i></button>
		<button type="button" (click)="onCancel()"><i class="fa fa-times"></i></button>
	</div>
	<div class="form-group" id="summernote">{{value}}</div>
</div>

<div *ngIf="!editMode && !simpleMode" class="view-mode" (dblclick)="onEdit()">
	<i *ngIf="!editMode" class="fa fa-pencil pointer" (click)="onEdit()" title="Edit"></i>
	<div [innerHtml]="value || '-'"></div>
</div>


// WEBPACK FOOTER //
// /app/src/app/components/fields/text-editor-field/text-editor-field.component.html